export default __webpack_public_path__ + "static/media/indoor-1.c1762854.png";